var _jsxFileName = "/opt/atlassian/pipelines/agent/build/src/components/utility/ActionBar/InAppActionBar.tsx";
import React from 'react';
import { ModalTopNavigation } from '@adc/parallax-component-library';
import { IconBack, IconClose } from '@adc/parallax-icons';
import mediator from 'Utilities/mediator';
const InAppActionBar = ({
  testID,
  title,
  closeBtn,
  onBack
}) => {
  return /*#__PURE__*/React.createElement(ModalTopNavigation, {
    title: title,
    testID: testID,
    maxLinesOfTitle: 1,
    buttonStart: {
      element: closeBtn ? /*#__PURE__*/React.createElement(IconClose, {
        testID: `${testID}.close-btn-icon`,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 23,
          columnNumber: 11
        }
      }) : /*#__PURE__*/React.createElement(IconBack, {
        testID: `${testID}.back-btn-icon`,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 25,
          columnNumber: 11
        }
      }),
      label: 'close',
      onPress: onBack ? onBack : () => mediator.publish('router:back')
    },
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 17,
      columnNumber: 5
    }
  });
};
export { InAppActionBar };